import { Grid, styled } from '@mui/material';
import DoughnutChart from './DoughnutChart';
import PortfolioCompositionList from './PortfolioCompositionList';
import { useGetPortfolioCompositionData } from './useGetPortfolioCompositionData';
import { PDFFooter } from '../../molecules/PDFFooter/PDFFooter';
import { PDFHeader } from '../../molecules/PDFHeader/PDFHeader';
import { PDFTitle } from '../PDF/PDFTitle';
import { GoalTypeEnum } from 'common/types';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '../../atoms/Typography/Typography';

export interface PDFPortfolioCompositionProps {
    recommendedPortfolioId: number;
    allMarketPortfolios: any;
    goalType: string;
    goalName: string;
    priority: 'Need' | 'Want' | 'Wish' | 'Dream' | 'onTrack' | 'offTrack' | 'atRisk';
    type: GoalTypeEnum;
    currentPage: number;
    totalPages: number;
    disclaimer?: string;
}

export const StyledDisclaimerContent = styled(Typography)(({ theme }) => ({
    fontWeight: 400,
    fontSize: theme.spacing(1.5),
    margin: `${theme.spacing(3)} 0`,
    lineHeight: theme.spacing(2),
    color: theme.palette.neutral[400]
}));

export const PDFPortfolioComposition = ({
    allMarketPortfolios,
    recommendedPortfolioId,
    goalType,
    goalName,
    priority,
    type,
    currentPage,
    totalPages,
    disclaimer
}: PDFPortfolioCompositionProps) => {
    const { t } = useTranslation();
    const { doughnutChartData, groupedPortfolio } = useGetPortfolioCompositionData(
        recommendedPortfolioId,
        allMarketPortfolios
    );

    return (
        <Grid height={'1000px'} position={'relative'} marginBottom={'40px'}>
            <PDFHeader pageName={t('PORTFOLIO_COMPOSITION_TITLE')} />
            <PDFTitle goalType={goalType} goalName={goalName} type={type} priority={priority} />
            <Grid container item direction="row" xs={12} spacing={2} mt={1} mb={2} flex={1} maxHeight={'60%'}>
                <Grid item xs={4}>
                    <DoughnutChart doughnutChartData={doughnutChartData} groupedPortfolio={groupedPortfolio} isPDF />
                </Grid>
                <Grid item xs={8}>
                    <PortfolioCompositionList portfolioListData={groupedPortfolio} isPDF />
                </Grid>
            </Grid>
            <Grid container item xs={12} mt={2}>
                <StyledDisclaimerContent label={<Trans i18nKey={disclaimer} components={{ strong: <strong /> }} />} />
            </Grid>
            <PDFFooter currentPage={currentPage} totalPages={totalPages} />
        </Grid>
    );
};
